import { render } from "./SelecionarIconeProcessoVendas.vue?vue&type=template&id=66f5f84e&scoped=true&ts=true"
import script from "./SelecionarIconeProcessoVendas.vue?vue&type=script&lang=ts"
export * from "./SelecionarIconeProcessoVendas.vue?vue&type=script&lang=ts"

import "./SelecionarIconeProcessoVendas.vue?vue&type=style&index=0&id=66f5f84e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f5f84e"]])

export default __exports__